import { render, staticRenderFns } from "./UserProductsSubMenusLinks.vue?vue&type=template&id=24e098ba"
import script from "./UserProductsSubMenusLinks.vue?vue&type=script&lang=js"
export * from "./UserProductsSubMenusLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24e098ba')) {
      api.createRecord('24e098ba', component.options)
    } else {
      api.reload('24e098ba', component.options)
    }
    module.hot.accept("./UserProductsSubMenusLinks.vue?vue&type=template&id=24e098ba", function () {
      api.rerender('24e098ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/sub-menus/products/UserProductsSubMenusLinks.vue"
export default component.exports